// Mutations
export const SET_LOGGED_IN = "SET_STATUS";
export const SET_USER = "SET_USER";

// Actions
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
